exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-3ced6119]{text-align:left;margin-bottom:0}.checkbox input[type=checkbox][data-v-3ced6119]{position:absolute}", ""]);

// exports
